module.exports = __webpack_public_path__ + "resources/img/facetec-3d-facemap-examples.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-3d-facemap-examples.png
// module id = 1244
// module chunks = 0